import { INITIAL_REAL_ESTATE_FILTERS } from "../constants/realEstateFilters";
import { listingModeToTransactionType } from "../constants/realEstateSearch";
import { PERSPECTIVE_IDS } from "../constants/perspectiveIds";

export const RESTORE_SAVED_SEARCH_KEY = "midpoint_restore_saved_search";
export const PENDING_FAVORITE_KEY = "midpoint_pending_favorite";
export const PENDING_SAVE_SEARCH_KEY = "midpoint_pending_save_search";

export function filtersToSavedPayload(filters = {}) {
  return {
    minPrice: filters.minPrice || null,
    maxPrice: filters.maxPrice || null,
    bedrooms: filters.minBedrooms || null,
    bathrooms: filters.minBathrooms || null,
    propertyTypes: filters.propertyType ? [filters.propertyType] : [],
    municipality: filters.municipality || null,
    neighborhood: filters.neighborhood || null,
    freeText: filters.searchQuery || null,
    transactionType: filters.transactionType || null,
    propertyType: filters.propertyType || null,
    listingStatus: filters.listingStatus || null,
    minBuildingAreaSqM: filters.minBuildingAreaSqM || null,
    maxBuildingAreaSqM: filters.maxBuildingAreaSqM || null,
  };
}

export function listingModeFromSavedSearch(saved) {
  if (saved.listingMode === "buy") {
    return "sale";
  }
  if (saved.listingMode === "rent") {
    return "rent";
  }
  if (saved.filters?.transactionType) {
    return saved.filters.transactionType;
  }
  return "rent";
}

export function savedSearchToFilters(saved) {
  const filters = saved.filters || {};

  return {
    ...INITIAL_REAL_ESTATE_FILTERS,
    transactionType: listingModeFromSavedSearch(saved),
    propertyType: filters.propertyType || filters.propertyTypes?.[0] || "",
    listingStatus: filters.listingStatus || "",
    minPrice: filters.minPrice != null ? String(filters.minPrice) : "",
    maxPrice: filters.maxPrice != null ? String(filters.maxPrice) : "",
    minBedrooms: filters.bedrooms != null ? String(filters.bedrooms) : "",
    minBathrooms: filters.bathrooms != null ? String(filters.bathrooms) : "",
    minBuildingAreaSqM:
      filters.minBuildingAreaSqM != null ? String(filters.minBuildingAreaSqM) : "",
    maxBuildingAreaSqM:
      filters.maxBuildingAreaSqM != null ? String(filters.maxBuildingAreaSqM) : "",
    neighborhood: filters.neighborhood || "",
    municipality: filters.municipality || "",
    searchQuery: saved.queryText || filters.freeText || "",
  };
}

export function storeSavedSearchRestore(savedSearch) {
  sessionStorage.setItem(
    RESTORE_SAVED_SEARCH_KEY,
    JSON.stringify({
      savedSearch,
      perspectiveId: PERSPECTIVE_IDS.REAL_ESTATE,
    })
  );
}

export function consumeSavedSearchRestore() {
  const raw = sessionStorage.getItem(RESTORE_SAVED_SEARCH_KEY);
  if (!raw) {
    return null;
  }

  sessionStorage.removeItem(RESTORE_SAVED_SEARCH_KEY);

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function suggestSavedSearchName(filters = {}) {
  const parts = [];

  if (filters.transactionType === "sale") {
    parts.push("Buy");
  } else if (filters.transactionType === "rent") {
    parts.push("Rent");
  }

  if (filters.neighborhood) {
    parts.push(filters.neighborhood);
  } else if (filters.municipality) {
    parts.push(filters.municipality);
  }

  if (filters.searchQuery) {
    parts.push(`"${filters.searchQuery.trim().slice(0, 40)}"`);
  }

  return parts.length ? parts.join(" · ") : "My saved search";
}

export function listingModeForApi(filters) {
  if (filters.transactionType === "sale") {
    return "buy";
  }
  if (filters.transactionType === "rent") {
    return "rent";
  }
  return "any";
}
